import React, { FC } from "react";

import './card.scss';

type TCardProps = {
    className?: string;
    title?: string;
    width?: string;
    avatarSize?: number;
    children?: any;
    id?: string
};

export const CardHeader:FC<TCardProps> = ({children, className}: TCardProps) => {
    return (
        <div className={`cardHeader ${className}`}>
            {children}
        </div>
    );
};

export const CardBody:FC<TCardProps> = ({children, className}: TCardProps) => {
    return (
        <div className={`cardBody ${className}`}>
            {children}
        </div>
    );
};

const Card: FC<TCardProps> = ({ className, width, children, id }: TCardProps) => {
    
    return (     
        <div className={`card ${className}`} id={id} style={{width: width}}>
            {children}
        </div>
    );
};

export default Card;
